import { combineReducers } from 'redux';

import byId from './byId';
import allIds from './allIds';

export const getEmployments = (state) => state.byId;
export const getEmployment = (state, id) => state.byId[id];
export const getEmploymentIds = (state) => state.allIds;

export default combineReducers({
  byId,
  allIds,
});
